"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertWeight = exports.convertLength = void 0;
const LENGTH_UNIT_TO_INCHES = {
    in: 1,
    cm: 0.3937,
    mm: 0.0394,
    m: 39.37,
};
const WEIGHT_UNIT_TO_POUNDS = {
    lb: 1,
    kg: 2.20462,
    g: 0.0022,
    oz: 0.0625,
};
const convertLength = (length, fromUnit, toUnit) => {
    return (length * LENGTH_UNIT_TO_INCHES[fromUnit]) / LENGTH_UNIT_TO_INCHES[toUnit];
};
exports.convertLength = convertLength;
const convertWeight = (weight, fromUnit, toUnit) => {
    return (weight * WEIGHT_UNIT_TO_POUNDS[fromUnit]) / WEIGHT_UNIT_TO_POUNDS[toUnit];
};
exports.convertWeight = convertWeight;
//# sourceMappingURL=UnitConversionUtils.js.map